import { createContext   } from "react";

interface DataState {
    loading: boolean;
}

export const init = {
    data: {
        loading: false,
    },
    setData: (data: DataState) => {},
};


export const ctx = createContext(init);
